// Écran de sélection des zones — affiché après "Besoins" et avant la 1ʳᵉ zone.
// Jordan voit toutes les zones groupées Intérieur/Extérieur, coche celles à évaluer,
// et clique "Démarrer" pour passer à la 1ʳᵉ zone cochée.
// Chaque toggle PATCH `selected_zones` immédiatement (auto-save).

import { Home, DoorOpen, CheckCircle2, ChevronRight } from "lucide-react";
import { Button } from "../ui/button";

export default function ZoneSelectionScreen({
  zonesConfig,
  zoneGroups,
  selectedZoneIds,
  onToggleZone,
  onStart,
}) {
  const selectedSet = new Set(selectedZoneIds);
  const totalSelected = selectedZoneIds.length;

  return (
    <div className="space-y-5" data-testid="mobile-dal-zone-selection">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 rounded-xl bg-cyan-500/20 flex items-center justify-center">
          <CheckCircle2 className="w-5 h-5 text-cyan-400" />
        </div>
        <div>
          <h2 className="text-[var(--oh-text)] text-lg font-medium">Zones à évaluer</h2>
          <p className="text-[var(--oh-text-secondary)] text-xs">Cochez uniquement les zones concernées par la visite</p>
        </div>
      </div>

      {zoneGroups.map(group => {
        const GroupIcon = group.id === "interieur" ? Home : DoorOpen;
        return (
          <section key={group.id} className="bg-[var(--oh-bg-elevated)] rounded-xl p-3 border border-[var(--oh-border)]">
            <div className="flex items-center gap-2 mb-3">
              <GroupIcon className="w-4 h-4 text-cyan-400" />
              <h3 className="text-cyan-300 text-sm font-medium uppercase tracking-wider">{group.name}</h3>
            </div>
            <div className="space-y-1.5">
              {group.zones.map(zoneId => {
                const zone = zonesConfig.find(z => z.id === zoneId);
                if (!zone) return null;
                const ZIcon = zone.icon;
                const isSelected = selectedSet.has(zoneId);
                return (
                  <button
                    key={zoneId}
                    type="button"
                    onClick={() => onToggleZone(zoneId)}
                    data-testid={`zone-toggle-${zoneId}`}
                    className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-left text-sm border transition-all ${
                      isSelected
                        ? "bg-cyan-500/15 border-cyan-500/50 text-[var(--oh-text)]"
                        : "bg-[var(--oh-bg-elevated)] border-[var(--oh-border)] text-[var(--oh-text-secondary)]"
                    }`}
                  >
                    <span
                      className={`w-5 h-5 rounded border-2 flex items-center justify-center shrink-0 ${
                        isSelected ? "border-cyan-400 bg-cyan-500/30" : "border-[var(--oh-border)]"
                      }`}
                    >
                      {isSelected && <CheckCircle2 className="w-3.5 h-3.5 text-cyan-300" />}
                    </span>
                    {ZIcon && <ZIcon className="w-4 h-4 shrink-0 opacity-70" />}
                    <span className="flex-1">{zone.name}</span>
                  </button>
                );
              })}
            </div>
          </section>
        );
      })}

      <Button
        onClick={onStart}
        className="w-full bg-orange-600 hover:bg-orange-700 h-12"
        data-testid="mobile-dal-zone-selection-start"
      >
        Démarrer ({totalSelected} zone{totalSelected > 1 ? "s" : ""})
        <ChevronRight className="w-5 h-5 ml-1" />
      </Button>
      <p className="text-center text-[var(--oh-text-muted)] text-xs">
        Tu peux modifier la sélection à tout moment depuis cet écran.
      </p>
    </div>
  );
}
